import { SponsorContentType, SponsorPlacement } from 'api';
import { PriceCard } from './types';

export const HEADLINER_PRICES: PriceCard[] = [
  {
    label: '$50 budget',
    value: 5000000,
    description: '500 listens',
  },
  {
    label: '$100 budget',
    value: 10000000,
    description: '1000 listens',
  },
  {
    label: '$200 budget',
    value: 20000000,
    description: '2000 listens',
  },
];

export const PUBNET_PRICES: PriceCard[] = [
  {
    label: '$100 budget',
    value: 10000000,
    description: '250 listens',
    type: 'proGrow',
  },
  {
    label: '$200 budget',
    value: 20000000,
    description: '500 listens',
  },
  {
    label: '$500 budget',
    value: 50000000,
    description: '1500 listens',
  },
  {
    label: '$1000 budget',
    value: 100000000,
    description: '3500 listens',
  },
];

export const YOUTUBE_PRICES: PriceCard[] = [
  {
    label: '$200 budget',
    value: 20000000,
    description: '500 views',
  },
  {
    label: '$500 budget',
    value: 50000000,
    description: '1500 views',
  },
  {
    label: '$1000 budget',
    value: 100000000,
    description: '3500 views',
  },
];

export const PRICES_BY_PLACEMENT: Record<SponsorPlacement, PriceCard[]> = {
  headlinerApp: HEADLINER_PRICES,
  publisherNetwork: PUBNET_PRICES,
  youtubePromotion: YOUTUBE_PRICES,
};

export const METRIC_BY_CONTENT_TYPE: Record<SponsorContentType, string> = {
  podcastEpisode: 'listens',
  youtubeVideo: 'views',
};
